import { render, staticRenderFns } from "./SubAccountBody.vue?vue&type=template&id=6f3a8b8f&scoped=true&"
import script from "./SubAccountBody.vue?vue&type=script&lang=ts&"
export * from "./SubAccountBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3a8b8f",
  null
  
)

export default component.exports